import { getType } from 'typesafe-actions';
import produce from 'immer';

import { ActionsOf } from '../../../helpers/actions';
import * as customersActions from './actions';

import { Customer } from 'src/components/modules/sites/types';

export interface CustomersEntityState {
  byId: { [Key: number]: { id: number; name: string } };
}

export interface CustomersStateSlice {
  entities: {
    customer: CustomersEntityState;
  };
}

export const initialState: CustomersEntityState = {
  byId: {},
};

type CustomerActions = ActionsOf<typeof customersActions>;

export const customersEntityReducer = produce(
  (draft: CustomersEntityState, action: CustomerActions) => {
    switch (action.type) {
      case getType(customersActions.getCustomersList.success): {
        const customers = action.payload.result as Customer[];

        draft.byId = {
          ...draft.byId,
          ...customers,
        };

        return;
      }

      default:
        break;
    }
  },
  initialState
);
